<template>
  <UiLanguageSelector
    :locales="store.enabledLocales"
    @select="onSelect"
    @dismiss="ui.hideLanguageSelector()"
  />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { setLocale } from '@/app/i18n';
import { router } from '@/app/router';
import { store } from '@/app/store';
import { useUiStore } from '@/app/stores/ui';
import { analytics } from '@/services/Analytics';
import { sentryService } from '@/services/telemetry/sentry';
import type { UiLocale } from '@/ui-kit';
// biome-ignore lint/correctness/noUnusedImports: used via tag <UiLanguageSelector> in <template>
import { UiLanguageSelector } from '@/ui-kit';

const $router = useRouter();
const ui = useUiStore();

onMounted(() => {
  analytics.trackBoolean(analytics.METRICS.language_select_initiated, {});
});

function onSelect(locale: UiLocale): void {
  sentryService.addBreadcrumb('user.interaction', 'Language selected', {
    new_locale: locale.code,
    new_locale_name: locale.title,
    previous_locale: store.currentLocale?.code,
  });

  ui.hideLanguageSelector();
  analytics.trackData(
    {
      [analytics.METRICS.language_selected]: locale.code,
    },
    {}
  );
  analytics.trackTimeTo(analytics.METRICS.time_language_select_success, {});

  setLocale(locale.code);
  $router.push(router.getLinkToLocale(locale.code));
}
</script>
